import chatApi from '../api/chatApi';

class ChatService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
  }

  // Room management
  async getChatRooms() {
    try {
      return await chatApi.getRooms();
    } catch (error) {
      console.error('Error fetching chat rooms:', error);
      throw error;
    }
  }

  async createRoom(roomData) {
    try {
      return await chatApi.createRoom(roomData);
    } catch (error) {
      console.error('Error creating room:', error);
      throw error;
    }
  }

  async joinRoom(roomId) {
    try {
      return await chatApi.joinRoom(roomId);
    } catch (error) {
      console.error('Error joining room:', error);
      throw error;
    }
  }

  // Message management
  async getMessages(roomId, limit = 50, offset = 0) {
    try {
      return await chatApi.getMessages(roomId, limit, offset);
    } catch (error) {
      console.error('Error fetching messages:', error);
      throw error;
    }
  }

  async sendMessage(roomId, messageData) {
    try {
      return await chatApi.sendMessage(roomId, messageData);
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  }

  async markRoomAsRead(roomId) {
    try {
      // This would mark all messages in the room as read
      return await chatApi.markRoomAsRead(roomId);
    } catch (error) {
      console.error('Error marking room as read:', error);
      throw error;
    }
  }

  // WebSocket connection
  connectWebSocket(roomId, token) {
    try {
      this.socket = chatApi.createWebSocketConnection(roomId, token);
      
      this.socket.onopen = () => {
        console.log('WebSocket connected');
        this.isConnected = true;
        this.reconnectAttempts = 0;
      };

      this.socket.onclose = () => {
        console.log('WebSocket disconnected');
        this.isConnected = false;
        this.handleReconnect(roomId, token);
      };

      this.socket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };

      return this.socket;
    } catch (error) {
      console.error('Error connecting WebSocket:', error);
      throw error;
    }
  }

  disconnectWebSocket() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
      this.isConnected = false;
    }
  }

  handleReconnect(roomId, token) {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 30000);
      
      setTimeout(() => {
        console.log(`Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts})`);
        this.connectWebSocket(roomId, token);
      }, delay);
    }
  }

  sendWebSocketMessage(data) {
    if (this.socket && this.isConnected) {
      this.socket.send(JSON.stringify(data));
    } else {
      console.warn('WebSocket not connected');
    }
  }
}

export const chatService = new ChatService();
export default chatService;